// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__XOfNf","header":"styles_header__1sB3S","back":"styles_back__1JfOq","title":"styles_title__1IxIK","content":"styles_content__2GGdn"};